"use client";

import React from "react";
import svgPaths from "@/assets/svg/svg-5s97axwnwx";
import SupportContactInlineForm from "@/components/sections/contact/SupportContactInlineForm";
import Script from "next/script";

export default function MobileContactUs() {
	return (
		<div className="bg-[#1a2c20] rounded-2xl p-6 mb-8">
			<div
				className="flex items-start gap-4 mb-6"
				style={{ alignItems: "center" }}
			>
				<div
					className="w-14 h-14 rounded-full flex items-center justify-center shrink-0"
					style={{
						background:
							"linear-gradient(90deg, rgba(101, 222, 158, 0.12), rgba(0, 0, 0, 0.05))",
					}}
				>
					<svg className="w-8 h-8" fill="none" viewBox="0 0 56 56">
						<path
							d={svgPaths.p26d12a20}
							fill="black"
							fillOpacity="0.05"
						/>
						<path
							d={svgPaths.p26d12a20}
							fill="#65DE9E"
							fillOpacity="0.12"
						/>
						<path d={svgPaths.p1c8f3080} fill="#A7FF5E" />
					</svg>
				</div>
				<div className="flex-1">
					<h2 className="text-white text-2xl font-bold">
						Contact Us
					</h2>
				</div>
			</div>

			<div className="flex items-center gap-4 mb-5">
				<div
					className="w-14 h-14 rounded-full backdrop-blur-md flex items-center justify-center shrink-0"
					style={{
						background:
							"linear-gradient(90deg, rgba(101, 222, 158, 0.12), rgba(0, 0, 0, 0.05))",
					}}
				>
					<svg className="w-8 h-8" fill="none" viewBox="0 0 32 32">
						<path d={svgPaths.p8f98a80} fill="#A7FF5E" />
					</svg>
				</div>
				<div className="flex-1">
					<p className="text-[#edffde] text-xs mb-0.5">Email us</p>
					<p className="text-white text-base font-medium">
						support@taxlienvest.com
					</p>
				</div>
			</div>

			<div className="flex items-center gap-4 mb-2">
				<div
					className="w-14 h-14 rounded-full backdrop-blur-md flex items-center justify-center shrink-0"
					style={{
						background:
							"linear-gradient(90deg, rgba(101, 222, 158, 0.12), rgba(0, 0, 0, 0.05))",
					}}
				>
					<svg className="w-8 h-8" fill="none" viewBox="0 0 32 32">
						<path d={svgPaths.pb44d500} fill="#A7FF5E" />
					</svg>
				</div>
				<div className="flex-1">
					<p className="text-[#edffde] text-xs mb-0.5">Call us</p>
					<p className="text-white text-base font-medium">
						+1 (321) 485-7963
					</p>
				</div>
			</div>
			<Script
				src="https://challenges.cloudflare.com/turnstile/v0/api.js"
				strategy="afterInteractive"
			/>
			<SupportContactInlineForm variant="mobile" idPrefix="mobile" />
		</div>
	);
}
